// MoveToBank.js

import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap-tabs";
import { getRequest } from "./../../Utils/AppApi";
import { GET_PARENT_PROFILE } from "../../Utils/appConstants";
import FundTransfer from "./../payoutCashFree/fundTransfer";
import { ToastContainer } from "react-toastify";
import { useHistory } from "react-router-dom";

function MoveToBank() {
  const history = useHistory();
  const [InEligibleLimit, setEligibleLimit] = useState(0);
  const [loading, setLoading] = useState(true);

  const getParentProfile = () => {
    getRequest(`${GET_PARENT_PROFILE}`, history)
      .then((response) => {
        if (response.success === true) {
          setEligibleLimit(response.data.eligibleAmount?.toFixed(2) || 0);
        } else {
          setEligibleLimit(0);
        }
      })
      .catch((error) => {
        console.error(error);
        setEligibleLimit(0);
      })
      .finally(() => {
        // ✅ No extra delay – skeleton hides as soon as API finishes
        setLoading(false);
      });
  };

  useEffect(() => {
    getParentProfile();
  }, []);

  // ============================================================
  //  REFINED SKELETON LOADER – matches real layout perfectly
  // ============================================================
  const SkeletonLoader = () => (
    <div className="content-wrapper pt-2 skeleton-wrapper">
      {/* Header */}
      <div className="content-header my-0 py-0">
        <div className="container-fluid">
          <div className="row mb-0 align-items-center">
            <div className="col-sm-12 d-flex justify-content-between">
              <h1 className="page-title font-merriweather skeleton-text" style={{ width: "180px", height: "32px" }}>
                Fund Settlement
              </h1>
              <span className="skeleton-text" style={{ width: "200px", height: "28px" }}>
                (Available Limit: <span className="skeleton-shimmer">0</span>)
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="content">
        <div className="container-fluid pt-2 pb-5">
          <div className="recharge-tabs skeleton-tabs">
            <div className="d-flex" style={{ gap: "20px", borderBottom: "1px solid #dee2e6", paddingBottom: "8px" }}>
              <div className="skeleton-text" style={{ width: "140px", height: "36px" }}></div>
              <div className="skeleton-text" style={{ width: "100px", height: "36px" }}></div>
              <div className="skeleton-text" style={{ width: "80px", height: "36px" }}></div>
            </div>
          </div>

          {/* FundTransfer component skeleton – mimics actual card content */}
          <div className="content card mt-3 skeleton-card" style={{ minHeight: "300px" }}>
            <div className="container-fluid pt-4 pb-4">
              <div className="row">
                {[...Array(6)].map((_, i) => (
                  <div key={i} className="col-sm-6 col-md-4 col-lg-4 mb-3">
                    <div className="skeleton-text" style={{ width: "70%", height: "18px", marginBottom: "8px" }}></div>
                    <div className="skeleton-text" style={{ width: "90%", height: "38px" }}></div>
                  </div>
                ))}
              </div>
              <div className="row mt-3">
                <div className="col-12 d-flex justify-content-end">
                  <div className="skeleton-text" style={{ width: "100px", height: "40px", marginRight: "12px" }}></div>
                  <div className="skeleton-text" style={{ width: "100px", height: "40px" }}></div>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-12">
                  <div className="skeleton-text" style={{ width: "150px", height: "24px", marginBottom: "12px" }}></div>
                  <div className="skeleton-text" style={{ width: "80%", height: "16px", marginBottom: "6px" }}></div>
                  <div className="skeleton-text" style={{ width: "70%", height: "16px", marginBottom: "6px" }}></div>
                  <div className="skeleton-text" style={{ width: "50%", height: "16px" }}></div>
                </div>
              </div>
            </div>
          </div>

          {/* Animated progress bar – subtle indicator */}
          <div className="mt-3">
            <div className="progress" style={{ height: "3px" }}>
              <div
                className="progress-bar progress-bar-striped progress-bar-animated"
                role="progressbar"
                style={{ width: "100%", backgroundColor: "#007bff" }}
              ></div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .skeleton-text {
          background: #f0f2f5;
          background-image: linear-gradient(
            90deg,
            #f0f2f5 25%,
            #e0e3e8 37%,
            #f0f2f5 63%
          );
          background-size: 400% 100%;
          animation: skeleton-shimmer 1.4s ease-in-out infinite;
          border-radius: 4px;
          display: inline-block;
        }
        .skeleton-card {
          background: #ffffff;
          border: 1px solid #e9ecef;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
        }
        .skeleton-tabs .skeleton-text {
          height: 36px;
          border-radius: 0;
          background: transparent;
          border-bottom: 3px solid transparent;
          animation: none;
        }
        .skeleton-tabs .skeleton-text:first-child {
          border-bottom-color: #007bff;
          background: transparent;
        }
        @keyframes skeleton-shimmer {
          0% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .content-wrapper {
          animation: fadeIn 0.25s ease-in-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(4px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .skeleton-wrapper {
          opacity: 0.9;
        }
      `}</style>
    </div>
  );

  // ============================================================
  //  MAIN RENDER
  // ============================================================
  return (
    <>
      {loading ? (
        <SkeletonLoader />
      ) : (
        <div>
          <div className="content-wrapper pt-2">
            <div className="content-header my-0 py-0">
              <div className="container-fluid">
                <div className="row mb-0 align-items-center">
                  <div className="col-sm-12 d-flex justify-content-between">
                    <h1 className="page-title text-blue font-merriweather">
                      Fund <span className="text-red">Settlement</span>
                    </h1>
                    <span className="text-red mb-0">
                      (Available Limit:{" "}
                      {new Intl.NumberFormat().format(InEligibleLimit)})
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="content">
              <div className="container-fluid pt-2 pb-5">
                <Tabs
                  className="recharge-tabs"
                  onSelect={(index, label) => {}}
                >
                  <Tab
                    eventKey={1}
                    label={
                      <div className="tabtext" title="Quick Settlement">
                        Fund Transfer
                      </div>
                    }
                  >
                    {InEligibleLimit <= 0 ? (
                      <div className="content card">
                        <div className="container-fluid pt-5 pb-5 text-center">
                          <h5 className="text-red mx-50">
                            You are not eligible to use this service. Feel free to
                            reach out to our Distributor / SR PAY Private Limited
                            support team.
                            <br /> Thank you for your understanding!
                          </h5>
                        </div>
                      </div>
                    ) : (
                      <FundTransfer />
                    )}
                  </Tab>
                </Tabs>
              </div>
            </div>
            <ToastContainer
              position="top-center"
              autoClose={5000}
              limit={2}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
          </div>
        </div>
      )}
    </>
  );
}

export default MoveToBank;